// extracted by mini-css-extract-plugin
export default {"main":"DefaultLayout_main__sDg3z","container":"DefaultLayout_container__IX7hm"};